import type { TFunction } from 'i18next';
import type { PatientBookingResponse } from '../../api/generated';
import type { TableColumn } from '../UI';
import {
  actionsColumn,
  entityNameCell,
  reasonColumn,
  resolveEntityNames,
  standardDateColumn,
  standardRepeatsColumn,
  standardTimeColumn
} from '../Bookings/shared';
import { PATIENT_BOOKING_TYPE_LABEL_KEYS } from './patientBookingConstants';

interface PatientBookingColumnHandlers {
  patientNameById: Map<string, string>;
  onEdit: (booking: PatientBookingResponse) => void;
  onDelete: (booking: PatientBookingResponse) => void;
}

export const getPatientBookingColumns = (
  t: TFunction,
  { patientNameById, onEdit, onDelete }: PatientBookingColumnHandlers
): TableColumn<PatientBookingResponse>[] => [
  {
    key: 'patients',
    header: t('patient-booking-col-patients'),
    render: (booking) => {
      const allLabelKey = PATIENT_BOOKING_TYPE_LABEL_KEYS[booking.patientBookingType];
      return entityNameCell({
        names: resolveEntityNames(booking.patientIds, patientNameById),
        allLabel: allLabelKey ? t(allLabelKey) : null
      });
    }
  },
  standardDateColumn(t, 'patient-booking-col-date'),
  standardRepeatsColumn(t, 'patient-booking-col-repeats'),
  standardTimeColumn(t, 'patient-booking-col-time'),
  reasonColumn(t, 'patient-booking-col-reason'),
  actionsColumn(t, {
    editKey: 'patient-booking-edit',
    deleteKey: 'patient-booking-delete-title',
    onEdit,
    onDelete
  })
];
